"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddSalesOrderLine = void 0;
const class_validator_1 = require("class-validator");
const common_1 = require("../../common");
class AddSalesOrderLine extends common_1.UpdateAction {
}
__decorate([
    class_validator_1.IsMongoId()
], AddSalesOrderLine.prototype, "orderHeaderId", void 0);
__decorate([
    class_validator_1.IsInt(),
    class_validator_1.Min(1),
    class_validator_1.Max(9999)
], AddSalesOrderLine.prototype, "lineNumber", void 0);
__decorate([
    class_validator_1.IsMongoId()
], AddSalesOrderLine.prototype, "productId", void 0);
__decorate([
    class_validator_1.IsNumber(),
    class_validator_1.Min(0)
], AddSalesOrderLine.prototype, "price", void 0);
__decorate([], AddSalesOrderLine.prototype, "dueDate", void 0);
__decorate([], AddSalesOrderLine.prototype, "shipDate", void 0);
__decorate([
    class_validator_1.IsNumber(),
    class_validator_1.Min(0)
], AddSalesOrderLine.prototype, "quantity", void 0);
exports.AddSalesOrderLine = AddSalesOrderLine;
//# sourceMappingURL=add-sales-order-line.action.js.map